import React, {ComponentProps, useEffect, useRef, useState} from "react";
import {Card, Col, Descriptions, Row, Space} from "antd";
import {Link} from "react-router-dom";
import * as apis from "../../../../apis/platforms/dealer/index";
import * as bulletinApi from "../../../../apis/bulletin";
import styles from "./index.module.css";
import {useRequest} from "ahooks";
import {PaymentStatusEnum, SalesOrderStatusEnum} from "../../../../utils/constants";
import html2canvas from "html2canvas";
import EChartsReact from "echarts-for-react";
import dayjs from "dayjs";
import DetailDrawer from "../../../bulletin/detailDrawer";


function Index(props:ComponentProps<any>) {
    const [todoInfo, setTodoInfo] = useState<any>({});
    const [chartTitles, setChartTitles] = useState<string[]>([]);
    const [chartAmounts, setChartAmounts] = useState<any[]>([]);
    const [bulletins, setBulletins] = useState<any[]>([]);
    const [selectedBulletin, setSelectedBulletin] = useState<any>(undefined);

    const {loading:loadingTodoInfo, runAsync:runTodoInfo} = useRequest(apis.getTodo,{
        manual: false,
        onSuccess(res){
            setTodoInfo(res.data.data);
        }
    });

    const {loading:loadingMonthData, runAsync: runMonthData} = useRequest(apis.getMonthData,{
        manual: false,
        onSuccess(res){
            const data=  res.data.data;
            const titles = [];
            const amounts = [];
            for (const item of data) {
                titles.push(item.type);
                amounts.push({value:item.value, label: {show: true, position: 'inside'}});
            }
            setChartTitles(titles);
            setChartAmounts(amounts);
        }
    });
    const {loading: loadingGetBulletin, runAsync: runGetBulletin} = useRequest(bulletinApi.getBulletinsList,{
        manual: false,
        defaultParams: [{page:1,limit:10}],
        onSuccess(res){
            setBulletins(res.data.data);
        }

    })


    const handleGenerateImage = ()=>{
        const container:HTMLDivElement = document.querySelector(`div.echarts-for-react`) as HTMLDivElement;
        if(container){
            html2canvas(container).then(canvas=>{
                const url = canvas.toDataURL('image/png');
                const a = document.createElement('a');
                a.href = url;
                a.download = '本月情况';
                a.click();
            })
        }
    }

    return (
        <div style={{padding: 15}}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Card title="待办事项" bordered={false} loading={loadingTodoInfo}>
                        <Descriptions title="待处理" layout={"horizontal"} column={4}>
                            <Descriptions.Item label="发货待确认">
                                <Link to={`/order/sales?status=${SalesOrderStatusEnum.DELIVERED}`}>{todoInfo.todo?.deliveredSalesOrder}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="待付款">
                                <Link to={`/order/sales?status=${SalesOrderStatusEnum.PAYMENT_PENDING}`}>{todoInfo.todo?.unpaidSalesOrder}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="订单待提交">
                                <Link to={`/order/sales?status=${SalesOrderStatusEnum.NOT_SUBMITTED}`}>{todoInfo.todo?.notSubmittedSalesOrder}</Link>
                            </Descriptions.Item>
                            <Descriptions.Item label="超账期订单">
                                <Link to={`/order/sales?status=${SalesOrderStatusEnum.OVERDUE_PENDING}`}>{todoInfo.todo?.overdueSalesOrder}</Link>
                            </Descriptions.Item>
                        </Descriptions>
                        <Descriptions title="业务数据" layout={"horizontal"} column={4}>
                            <Descriptions.Item label="合同"><Link to={`/contract/contract?thisWeekNew=1`}>{todoInfo.business?.contract}</Link></Descriptions.Item>
                            <Descriptions.Item label="订单"><Link to={`/order/sales?thisWeekNew=1`}>{todoInfo.business?.salesOrder}</Link></Descriptions.Item>
                            <Descriptions.Item label="付款单"><Link to={`/finance/receipt?thisWeekNew=1`}>{todoInfo.business?.financeReceipt}</Link></Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="公告" bordered={false} extra={<Link to={'/sys/bulletin'}>更多</Link>}>
                        <div className={styles.BulletinContainer}>
                            {
                                bulletins.map((b:any)=>(
                                    <p className={styles.Item} onClick={()=>setSelectedBulletin(b)}><span className={styles.Title}>{b.title}</span><span>{dayjs(b.publishTime).format('lll')}</span></p>
                                ))
                            }
                        </div>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card title="本月情况" bordered={false} loading={loadingMonthData} extra={<a onClick={handleGenerateImage}>生成图片</a>}>
                        <EChartsReact option={{
                            xAxis: {
                                type: 'category',
                                data: chartTitles
                            },
                            yAxis: {
                                type: 'value',
                            },
                            series: {
                                data: chartAmounts,
                                type: 'bar',

                            }
                        }}/>
                    </Card>
                </Col>
            </Row>
            <DetailDrawer visible={!!selectedBulletin} onClose={()=>setSelectedBulletin(undefined)} bulletin={selectedBulletin}/>
        </div>
    )
}

export default Index;